import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ConfigService } from '../services/config.service';

@Injectable({
  providedIn: 'root'
})
export class VariantSelectorGuard implements CanActivate {

  constructor(public configService: ConfigService, public router: Router) { }

  async canActivate(): Promise<boolean> {
    //Wait for the company info to be loaded
    await this.configService.getInitialInfo()
    // Now validate if the company has multiple variants
    let variants = this.configService.company_info.variants;
    if (variants.length > 1) {
      return true;
    }
    this.router.navigateByUrl('/inicio');
    return false;
  }

}
